<script setup>
import { ref, onMounted } from 'vue'

const isDark = ref(false)

function applyTheme(theme) {
  const root = document.documentElement
  if (theme === 'dark') root.classList.add('dark')
  else root.classList.remove('dark')
  localStorage.setItem('theme', theme)
}

function toggle() {
  isDark.value = !isDark.value
  applyTheme(isDark.value ? 'dark' : 'light')
}

onMounted(() => {
  const isCurrentlyDark = document.documentElement.classList.contains('dark')
  isDark.value = isCurrentlyDark
})
</script>

<template>
  <!-- iOS-style pill switch -->
  <button
    class="relative inline-flex h-7 w-12 items-center rounded-full transition border border-border
           bg-white/70 dark:bg-white/10 hover:bg-white/80 dark:hover:bg-white/15"
    :aria-pressed="isDark"
    @click="toggle"
  >
    <span
      class="pointer-events-none absolute left-1.5 h-4.5 w-4.5 rounded-full bg-white shadow
             transition-transform will-change-transform"
      :class="isDark ? 'translate-x-5' : 'translate-x-0'"
    />
    <span class="absolute left-1 text-[10px] opacity-70 dark:opacity-0">☀️</span>
    <span class="absolute right-1 text-[10px] opacity-0 dark:opacity-70">🌙</span>
  </button>
</template>

<style scoped>
.h-4.5{height:1.125rem}
.w-4.5{width:1.125rem}
</style>
